import { useMutation } from "@tanstack/react-query";
import { UsersApiConfirmUserRequest, buildUsersApi } from "@rentablo/api/apiv1";

const confirmSignup = async (params: UsersApiConfirmUserRequest) => {
  const api = buildUsersApi();

  const { data } = await api.confirmUser(params);
  return data;
};

export const useConfirmSignup = () => {
  return useMutation({
    mutationFn: confirmSignup,
  });
};
